export default class NoBodyReceivedError extends Error {}
